export default __webpack_public_path__ + "static/media/Initiate's Pants of the Waning Moon.1b771c5e.jpg";